import { FC, ReactNode } from "react";
import CheckIcon from "../assets/li_check.svg";
import { useMergedConfig } from "../context/MergedConfigProvider";
import { usePlatformAutoLogin } from "../hooks/usePlatformAutoLogin";
import { useIsMobile } from "../utils/useIsMobile";
import { BaseScreen } from "./BaseScreen";

const PLATFORM_LINK = import.meta.env.VITE_PLATFORM_URL_MAP;
const APP_ONE_LINK = import.meta.env.VITE_APP_ONE_LINK;

export type ThankYouScreenProps = {
  embedded: boolean;
  csrfToken: string;
  context?: "Live" | "Demo";
  userEmail?: string;
  userPassword?: string;
};

type WrapperProps = ThankYouScreenProps & {
  title: string;
  disableOnMobile?: boolean;
  children: ReactNode;
};

const ThankYouScreenWrapper: FC<WrapperProps> = ({
  embedded,
  csrfToken,
  title,
  disableOnMobile = false,
  userEmail,
  userPassword,
  children,
}) => {
  const isMobile = useIsMobile();
  const { iaid } = useMergedConfig();

  let platformLink = PLATFORM_LINK;
  if (iaid) {
    const [base, hash = ""] = platformLink.split("#");
    const [hashPath, hashQuery = ""] = hash.split("?");
    const params = new URLSearchParams(hashQuery);
    params.set("iaid", iaid);
    platformLink = `${base}#${hashPath}?${params.toString()}`;
  }

  const { isSubmitting, onSubmit } = usePlatformAutoLogin({
    embedded,
    isMobile,
    csrfToken,
    platformLink,
    appOneLink: APP_ONE_LINK,
    userEmail,
    userPassword,
  });

  const isDisabled = disableOnMobile && isMobile;

  return (
    <BaseScreen
      formTitle={title}
      formSubtitle=""
      headerIcon={CheckIcon}
      footerBtnLabel={isDisabled ? "Not available on mobile" : (embedded ? "Finish" : "Log in")}
      footerBtnOnClick={onSubmit}
      footerBtnLoading={isSubmitting}
      footerBtnDisabled={isDisabled || isSubmitting}
    >
      {children}
    </BaseScreen>
  );
};

export default ThankYouScreenWrapper;
